<a [matTooltip]="'ORDERS.COMMON.ORDER_ID.info_link_tooltip' | translate"
  [project-route]="link"
  color="primary"
  mat-icon-button>
  <mat-icon class="material-icons-outlined">visibility</mat-icon>
</a>

@if (!skeletonView) {
  <app-heading
    [headTooltip]="'ORDERS.COMMON.ORDER_ID.order_id_tooltip' | translate"
    [subTooltip]="'ORDERS.COMMON.ORDER_ID.project_id_tooltip' | translate"
    [subtitle]="order.lgStandingData.outProjectId"
    [title]="order.lgStandingData.outOrderId"
    hAlign="center">
  </app-heading>
} @else {
  <ngx-skeleton-loader [count]="1" [theme]="{ height: '30px', width: '50px' }"></ngx-skeleton-loader>
}
